import { render } from "./Docs.vue?vue&type=template&id=78de0384&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=78de0384&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78de0384"]])

export default __exports__